import { PostAPI } from "../helper/apiHelper";

export const ForgotPassword = async (request: any) => {
  return PostAPI(request, "Credential/ForgotPasswordGenerateOTP");
};
export const VerifyOTP = async (request: any) => {
  return PostAPI(request, "Credential/VerifyForgotPasswordOTP");
};